import { absolutePath } from "./absolutePath";

export const supportedCurrencies = {
  index: (params: Record<string, unknown>) =>
    absolutePath("supported_currencies", params),
};
